import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`

export const Sessions = styled.div`
  ${FontWeights.DemiBold};
  ${Typography.S};
`

export const Price = styled.div`
  ${FontWeights.Medium};
  ${Typography.Subhead};
  color: ${Colors.Neutral50};
`

export const PerSession = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
`
